module.exports = __webpack_public_path__ + "statics/img/1-5.c8ab6a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/1-5.png
// module id = r+9k
// module chunks = 1